var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1045_8747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.458 2.37459C13.6659 2.16666 13.9128 2.00173 14.1844 1.8892C14.4561 1.77667 14.7473 1.71875 15.0413 1.71875C15.3354 1.71875 15.6266 1.77667 15.8982 1.8892C16.1699 2.00173 16.4167 2.16666 16.6247 2.37459C16.8326 2.58251 16.9975 2.82936 17.1101 3.10103C17.2226 3.3727 17.2805 3.66387 17.2805 3.95792C17.2805 4.25197 17.2226 4.54315 17.1101 4.81482C16.9975 5.08648 16.8326 5.33333 16.6247 5.54126L5.93717 16.2288L1.58301 17.4163L2.77051 13.0621L13.458 2.37459Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_8747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.e9a6763cf0a96b7227bf85a68600b790.svg";
export { ForwardRef as ReactComponent };